export enum AssembleiaTipo {
  Nucleo = 'AGN',
  GeralOrdinaria = 'AGO',
  GeralExtraordinaria = 'AGE',
  GeralOrdinariaExtraordinaria = 'AOE',
  Reuniao = 'REU',
}

export enum AssembleiaTipoNumber {
  'AGO' = 1,
  'AGE',
  'AGN',
  'REU',
  'AOE',
}
